import ReviewStars from './review-stars'

export interface ReviewsHeaderProps {
  headerTitle?: string
  buttonText?: string
  buttonHref?: string
  averageRating?: number | null
  reviewCount?: number | null
  loading?: boolean
  hideOverallRating?: boolean
}

export function ReviewsHeader({
  headerTitle = 'What Our Customers Say',
  buttonText,
  buttonHref,
  averageRating,
  reviewCount,
  loading = false,
  hideOverallRating = false
}: ReviewsHeaderProps) {
  // buttonText has a schema default ('Review us'), so the href is the opt-in
  // gate: no link is rendered until the customer sets one (#672).
  const showButton = Boolean(buttonHref && buttonText)
  return (
    <div className="homerunner-reviews-header flex flex-col items-center">
      <div className="homerunner-reviews-header-content w-full mx-auto bg-muted rounded-2xl p-8 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="homerunner-reviews-header-left flex flex-col items-start gap-2 w-full sm:w-auto">
          <h2 className="homerunner-reviews-header-title text-3xl font-bold text-foreground">{headerTitle}</h2>
          {showButton && (
            <a
              href={buttonHref}
              className="homerunner-reviews-header-button bg-accent text-primary-foreground hover:bg-accent/90 px-5 py-2.5 rounded-md font-medium transition-colors shadow no-underline"
            >
              {buttonText}
            </a>
          )}
        </div>
        {!hideOverallRating && (
          <div className="homerunner-reviews-header-right flex flex-col items-end gap-2 w-full sm:w-auto">
            <div className="homerunner-reviews-header-rating flex items-center gap-2">
              {loading ? (
                <>
                  <span className="homerunner-reviews-header-rating-loading text-3xl font-semibold animate-pulse bg-muted-foreground/20 rounded w-16 h-10"></span>
                  <div className="homerunner-reviews-header-stars-loading flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="homerunner-reviews-header-star-loading w-6 h-6 animate-pulse bg-muted-foreground/20 rounded"></div>
                    ))}
                  </div>
                  <span className="homerunner-reviews-header-count-loading text-muted-foreground text-lg animate-pulse bg-muted-foreground/20 rounded w-20 h-6"></span>
                </>
              ) : (
                <>
                  <span className="homerunner-reviews-header-average-rating text-3xl font-semibold text-foreground">
                    {averageRating !== null && averageRating !== undefined ? averageRating.toFixed(1) : 'N/A'}
                  </span>
                  {averageRating !== null && averageRating !== undefined ? (
                    <div className="homerunner-reviews-header-stars">
                      <ReviewStars rating={averageRating} starClass="w-6 h-6" />
                    </div>
                  ) : (
                    <span className="homerunner-reviews-header-no-rating text-muted-foreground text-lg">No rating</span>
                  )}
                  <span className="homerunner-reviews-header-review-count text-muted-foreground text-lg">
                    ({reviewCount !== null && reviewCount !== undefined ? reviewCount.toLocaleString() : 'N/A'})
                  </span>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
